var exports = {
  "C": "PromptActions__cCqDxQ",
};

module.exports = exports;
